/* Penberry PDP — minimal vanilla JS, no framework, no dependencies */
(function () {
  var pdp = document.querySelector('[data-pdp]');
  if (!pdp) return;

  /* Gallery: swipeable main track synced with thumbnails */
  var mainTrack = pdp.querySelector('[data-main-track]');
  var slides = pdp.querySelectorAll('[data-main-slide]');
  var thumbsWrap = pdp.querySelector('.pdp__thumbs');
  var thumbs = thumbsWrap ? thumbsWrap.querySelectorAll('[data-thumb]') : [];

  function setActiveThumb(index) {
    thumbs.forEach(function (t) { t.classList.remove('is-active'); });
    if (thumbs[index]) thumbs[index].classList.add('is-active');
  }

  /* Clicking a thumbnail scrolls the main track to that slide */
  if (mainTrack && thumbsWrap && slides.length) {
    thumbsWrap.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumb]');
      if (!thumb || !thumbsWrap.contains(thumb)) return;
      e.preventDefault();
      var index = parseInt(thumb.getAttribute('data-index'), 10) || 0;
      var target = slides[index];
      if (target) {
        mainTrack.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }
      setActiveThumb(index);
    });

    /* Swiping the main track updates the active thumbnail */
    var scrollTimeout;
    mainTrack.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        var trackLeft = mainTrack.scrollLeft;
        var closestIndex = 0;
        var closestDist = Infinity;
        slides.forEach(function (slide, i) {
          var dist = Math.abs(slide.offsetLeft - trackLeft);
          if (dist < closestDist) {
            closestDist = dist;
            closestIndex = i;
          }
        });
        setActiveThumb(closestIndex);
      }, 100);
    }, { passive: true });
  }

  /* Quantity stepper */
  var qtyInput = pdp.querySelector('[data-pdp-form] .pdp__qty-input');
  var qtyMinus = pdp.querySelector('[data-qty-minus]');
  var qtyPlus = pdp.querySelector('[data-qty-plus]');
  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, v - 1);
    });
    qtyPlus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = v + 1;
    });
  }

  /* Variant option pills (single-select per option group) */
  var optionGroups = pdp.querySelectorAll('.pdp__option');
  optionGroups.forEach(function (group) {
    var pills = group.querySelectorAll('.pdp__option-pill');
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        /* NOTE: wire this up to Shopify's variant JSON (product.js / Section Rendering API)
           to update price, image, and hidden variant id input when you have multiple variants. */
      });
    });
  });

  /* Sticky Add to Cart bar: show after main ATC scrolls out of view */
  var stickyBar = pdp.querySelector('[data-sticky-bar]');
  var mainAtc = pdp.querySelector('[data-atc-button]');
  if (stickyBar && mainAtc && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBar.hidden = entry.isIntersecting;
        });
      },
      { rootMargin: '0px 0px -20% 0px' }
    );
    observer.observe(mainAtc);

    var stickyAtcBtn = pdp.querySelector('[data-sticky-atc]');
    if (stickyAtcBtn) {
      stickyAtcBtn.addEventListener('click', function () {
        mainAtc.click();
        mainAtc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  /* ============ ADD TO CART: open the cart drawer instead of redirecting to /cart ============
     Shopify's /cart/add endpoint redirects the browser to the cart page on a normal form
     POST. To keep the shopper on the PDP (better conversion, fewer drop-offs), we intercept
     the submit, add the item via fetch, and render the result straight into <cart-drawer>. */
  var pdpForm = pdp.querySelector('[data-pdp-form]');
  if (pdpForm && window.fetch) {
    pdpForm.addEventListener('submit', function (evt) {
      var submitter = evt.submitter || document.activeElement;

      /* "Buy It Now" must stay a real form submission so Shopify can redirect to checkout. */
      if (submitter && submitter.name === 'checkout') return;

      evt.preventDefault();

      var atcBtn = pdp.querySelector('[data-atc-button]');
      if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.classList.add('is-loading');
      }

      var cartDrawer = document.querySelector('cart-drawer');
      var formData = new FormData(pdpForm);

      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cartDrawer.getSectionsToRender().map(function (section) { return section.id; })
        );
        formData.append('sections_url', window.location.pathname);
      }

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json',
        },
        body: formData,
      })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (data.status) {
            /* Shopify rejected the add (e.g. sold out / inventory changed mid-visit). */
            var message = data.description || data.message || 'This item could not be added to your cart.';
            window.alert(message);
            return;
          }

          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(data);
          } else {
            /* Fallback so a shopper is never stuck: send them to the cart page. */
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        })
        .finally(function () {
          if (atcBtn) {
            atcBtn.disabled = false;
            atcBtn.classList.remove('is-loading');
          }
        });
    });
  }
})();
